import { Button, Card, Col, Flex, Form, List, Modal, Row, Upload } from "antd";
import { Alert } from "components/elements";
import TableAntd from "components/elements/Table/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import { ReactComponent as HistoryIcon } from "../../../assets/icon/historyIcon.svg";
import { ReactComponent as EyeCloseIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as UploadIcon } from "../../../assets/icon/uploadIcon.svg";
import { ReactComponent as ExcelIcon } from "../../../assets/icon/excelIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import WhiteListFilter from "../components/WhiteListFilter";
import * as services from "../services/whiteListApi";
import { setDropdownProduct, setIsLoading, setWhiteListData } from "../slices/whiteListSlice";
import styles from "../styles/BeCashStyles.module.css";
import HistoryFilesTable from "../page/HistoryFilesTable";
import useOptions from "features/masterData/hooks/useOptions";

const useWhiteList = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const { whiteListData, isLoading, dropdownProduct } = useSelector((state) => state?.whitelist)
    const [dataSource, setDataSource] = useState([])
    const [fileList, setFileList] = useState()
    const [openModal, setOpenModal] = useState(false)
    const [openHistoryModal, setOpenHistoryModal] = useState(false)
    // console.log("dataSource", dataSource);
    const [pagination, setPagination] = useState({ page: 0, size: 10, pageSize: 10 });
    const [paginationHistory, setPaginationHistory] = useState({ page: 0, size: 10, pageSize: 10 });
    const [amountVisible, setAmountVisible] = useState(true)
    const [productCode, setProductCode] = useState(null)
    const [useFilter, setUseFilter] = useState(false);
    const currentCompany = useSelector((state) => state?.company?.currentCompany);
    const [valuesChange, setValuesChange] = useState()
    const { employeeStatusTypeOptions, getEmployeeStstuaTypeOptions } = useOptions();
    const { Dragger } = Upload;
    const [disableButton, setDisableButton] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false)

    console.log("dropdownProduct", dropdownProduct);
    const feeTypeOption = [
        {
            label: 'ค่าติดตามทวงถามหนี้',
            value: 'FEE_01'
        },
        {
            label: 'ค่าธรรมเนียมการใช้วงเงิน',
            value: 'FEE_02'
        }
    ]

    useEffect(() => {

        setDataSource(whiteListData?.map?.((o, index) => {
            return {
                index,
                ...o,
                productName: o?.product?.["name" + (i18n.language == 'en' ? "En" : "")],
                // id: o?.employeeNo ,
                // accountNo: o?.bankNo ,
                // Maximum: o?.creditLimit ,
            }
        }))

    }, [whiteListData, i18n.language])

    async function callUpload() {
        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: (i18n.language === "en"
                ? <span>Are you sure confirm to upload ?</span>
                : <span>คุณแน่ใจที่จะยืนยันการอัปโหลดหรือไม่ ?</span>
            ),
            async onOk() {
                // console.log("file", fileList);
                //   createAttendanceShifts(modifiedValues);
                let res = await services.importWhitelist({ file: fileList?.[0] });
                if (res?.data?.status?.code == "200") {
                    console.log("res", res);
                    getWhiteList(pagination, productCode)
                    setOpenModal(false)
                    setFileList(null)
                    Alert({ message: "Success" });
                }
            },
            okText: t("common.confirm").toUpperCase(),
            cancelText: t("common.cancel").toUpperCase(),
        });
    }

    function xlsxIcon() {
        return <svg width="30" height="30" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.4843 1.84619H9.84619V3.6825H11.7114V4.93235H9.84619V6.15388H11.6923V7.38465H9.84619V8.61542H11.6923V9.84619H9.84619V11.077H11.6923V12.3077H9.84619V14.1539H15.4843C15.768 14.1539 16 13.9133 16 13.6185V2.38158C16 2.08681 15.768 1.84619 15.4843 1.84619ZM14.7693 12.3077H12.3077V11.077H14.7693V12.3077ZM14.7693 9.84619H12.3077V8.61542H14.7693V9.84619ZM14.7693 7.38465H12.3077V6.15388H14.7693V7.38465ZM14.7693 4.92311H12.3077V3.69235H14.7693V4.92311Z" fill="#1E6E42" />
            <path d="M0 1.77785V14.2228L9.23077 16V0L0 1.77785ZM5.83877 11.1262L4.76492 9.096C4.72431 9.02031 4.68246 8.88123 4.63877 8.67877H4.62215C4.60185 8.77415 4.55385 8.91938 4.47815 9.11385L3.40062 11.1262H1.72738L3.71385 8.00985L1.89662 4.89292H3.60492L4.496 6.76185C4.56554 6.90954 4.62769 7.08492 4.68308 7.28738H4.70031C4.73538 7.16554 4.80062 6.98462 4.896 6.744L5.88677 4.89231H7.45108L5.58215 7.98277L7.50338 11.1255L5.83877 11.1262Z" fill="#1E6E42" />
        </svg>
    }

    const modalDownload = useCallback(async () => {
        try {
            setIsDownloading(true);
            await services.exportExcelWhitelist().then(res => {
                console.log("res", res);
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "import-whitelist-template.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
        } catch (error) {
        } finally {
            setIsDownloading(false);
        }
    },
        [],
    )

    const ModalUpload = useCallback(
        () => {
            function fileSize(item) {
                if (item.size / 1000000 > 1) {
                    return (item.size / 1000000) + " mb"
                } else if (item.size / 1000 > 1) {
                    return (item.size / 1000) + " kb"
                } else {
                    return item.size + " byte"
                }
            }

            return <Modal
                destroyOnClose
                closable={false}
                open={openModal}
                footer={
                    <Row style={{ marginTop: "24px", justifyContent: "end", gap: 12 }}>
                        <Button onClick={() => {
                            setFileList(null)
                            setOpenModal(false)
                        }} style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}>
                            {t('action.cancel')}
                        </Button>
                        <Button type="primary" onClick={() => {
                            callUpload()
                        }}
                            style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: !fileList?.length ? "" : "var(--button-color)" }}
                            disabled={!fileList?.length}
                        >
                            {t('action.submit')}
                        </Button>

                    </Row>
                }
                title={
                    <Form.Item
                        colon={false}
                        label={<span style={{ fontSize: "16px", color: "#475467" }}>{t("common.import_data")}</span>}
                    >
                    </Form.Item>
                }
                onCancel={() => {
                    setFileList(null)
                    setOpenModal(false)
                }}
                onOk={() => {
                    callUpload()
                }}>
                {/* <Upload type="drag" maxCount={1} showUploadList={true} beforeUpload={(info) => {
                    return false;
                }
                } onChange={(info) => {
                    console.log(info?.file, info?.fileList);
                    setFileList(info?.file)
                    // setFileList(info.file)
                }}>{t('whiteList..upload')}</Upload> */}
                <Dragger
                    fileList={fileList}
                    type="drag"
                    maxCount={1}
                    listType="picture"
                    showUploadList={true}
                    style={{ backgroundColor: "white", borderRadius: "12px" }}
                    onDrop={(e) => {
                        console.log("onDrop", e);
                    }}
                    itemRender={(e, file, fileList, action) => {
                        return <List dataSource={fileList}
                            renderItem={(item) => (
                                <List.Item key={1}>
                                    <List.Item.Meta
                                        avatar={xlsxIcon()}
                                        title={item.name}
                                        description={fileSize(item)}
                                    />
                                    <Button
                                        style={{ border: "transparent" }}
                                        icon={"x"}
                                        onClick={() => { action.remove() }}
                                    >
                                    </Button>
                                </List.Item>
                            )}
                        />
                    }}
                    beforeUpload={(info) => {
                        return false;
                    }

                    }
                    onChange={(info) => {
                        console.log("info", info);
                        if (info.file?.name && !info.file?.name?.endsWith("xlsx")) {
                            Alert({ type: "error", message: "ระบบรองรับไฟล์ xlsx", noti: true })
                            setFileList(null)
                        } else if (info.file?.name) {
                            console.log("info?.file", info?.file);
                            setFileList([info?.file])
                        }
                    }}
                    onRemove={() => {
                        console.log("onRemove");
                        setFileList(null)
                    }}
                >
                    <Flex style={{
                        height: "20vh",
                        rowGap: "14px"
                    }} vertical justify="center" align="center">
                        <Flex style={{ width: "10%" }} ><UploadIcon /></Flex>
                        <Flex>
                            <span style={{ color: "#2CADE7", fontWeight: "bold" }}>{t("common.choose_file")}</span>
                            &nbsp;
                            <span style={{ color: "#475467" }}>{t("common.upload_dnd")}</span>
                        </Flex>

                    </Flex>
                </Dragger>
                {!fileList?.length > 0 &&
                    <Flex style={{
                        marginTop: "15px",
                        rowGap: "15px"
                    }} gap={5} vertical>
                        <span style={{ color: "#475467" }}>{t("common.file_support")}</span>


                        <Card
                            style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                            styles={{ body: { padding: "16px" } }}
                        >
                            <Row style={{ width: "100%" }}>
                                <Col span={16}>
                                    <Flex gap={16} align="center">
                                        <ExcelIcon />
                                        <Flex vertical>
                                            <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("employee.label.blank_form")}</span>
                                            <span style={{ color: "#42526D" }}>{t("employee.label.template_description")}</span>
                                        </Flex>
                                    </Flex>
                                </Col>
                                <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                                    <Button type="default" style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                        onClick={() => { modalDownload(); }}
                                        loading={isDownloading}
                                        disabled={isDownloading}
                                        icon={
                                            !isDownloading ? (
                                                <DownloadIcon style={{ fontSize: 16 }} />
                                            ) : (
                                                <span style={{ width: 16, height: 16 }} />
                                            )
                                        }
                                    >
                                        <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Flex>}
            </Modal>
        },
        [callUpload, openModal, t],
    )

    const getFileHistoryFn = useCallback(async (cb = () => { }, page) => {
        try {
            console.log("paginationHistory", paginationHistory, page);

            dispatch(setIsLoading(true));
            let pageUse = { ...(page ? page : paginationHistory) }
            console.log("pagination pageUse", pageUse);
            const response = await services.getFileHistory({
                companyId: currentCompany,
                ...pageUse
            });


            setPaginationHistory({
                ...pageUse,
                page: response.data?.pageNo,
                current: response.data?.pageNo + 1,
                // pageSize: response.data?.size,
                // size: response.data?.size,
                total: response.data?.totalItems ?? response.data?.page?.totalElements,
            });
            if (cb)
                cb?.(response?.data?.content)
            // dispatch(setDropdownProduct(response.data || []));
        } catch (error) {
            Alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, paginationHistory]);


    const ModalHistoryFilesTable = useCallback(
        () => {
            // dataSource = 
            return <HistoryFilesTable
                isModalOpen={openHistoryModal}
                pagination={paginationHistory}
                getFileHistoryFn={getFileHistoryFn}
                setPagination={setPaginationHistory}
                onCancel={() => {
                    setOpenHistoryModal(false)
                    setPaginationHistory({ page: 0, size: 10, pageSize: 10 })
                }}
                onOk={() => {
                    callUpload()
                }}>
            </HistoryFilesTable>
        },
        [getFileHistoryFn, openHistoryModal, paginationHistory],
    )

    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            render: (_, record, idx) => {
                console.log("idx ", idx, pagination);
                return ((pagination.page) * pagination.size) + (idx + 1);
            },
        },
        {
            title: <div className="text-table">{t('whiteList.productname')}</div>,
            dataIndex: 'productName',
            key: 'productName',
            align: "center"
        },
        {
            title: <div className="text-table">{t('whiteList..employeeNO')}</div>,
            dataIndex: 'employeeNo',
            key: 'employeeNo',
            sorter: true,
            align: "center"
        },
        {
            title: <div className="text-table">{t('whiteList..name')}</div>,
            dataIndex: i18n.language == 'en' ? 'nameEn' : 'name',
            key: 'name',
            align: "left",
            sorter: true,
            render: (_, record) => {
                return i18n.language === 'en' ? record?.nameEn : record?.name
            }
        },
        {
            title: <div className="text-table">{t('stauts')}</div>,
            dataIndex: i18n.language == 'en' ? 'statusEn' : 'status',
            key: 'status',
            align: "left",
            sorter: true,
            render: (_, record) => {
                return i18n.language === 'en' ? record?.statusEn : record?.status
            }
        },
        {
            title: <div className="text-table">{t('whiteList.bankNo')}</div>,
            dataIndex: 'bankNo',
            key: 'bankNo',
            align: "center",
            render: (_, record) => {
                let leng = _?.length && _?.length > 4 ? 4 : _?.length ?? 0
                let regex = new RegExp(`.{${leng}}$`);
                if (amountVisible) return _?.replace(regex, "XXXX")
                return (
                    _
                )
            }
        },
        {
            title: <div className="text-table">{t('whiteList..credit')}</div>,
            dataIndex: 'creditLimit',
            key: 'creditLimit',
            align: "right",
            sorter: true,
            render: (_, record) => {
                return (
                    amountVisible ? "xxxx.xx" : get2DecimalPointsWithCommas(record?.creditLimit)
                )
            }
        },
        {
            title: <div className="text-table">{t("product.interest_year")}</div>,
            dataIndex: 'interestRate',
            key: 'interestRate',
            align: "right",
            sorter: true,
            render: (_, record) => {
                return (
                    record?.interestRate && get2DecimalPointsWithCommas(record?.interestRate) + ' %'
                )
            }
        },
        {
            title: <div className="text-table">{t("product.fee")}</div>,
            dataIndex: 'feeTypeList',
            key: 'feeTypeList',
            align: "center",
            // sorter: true,
            render: (_, record) => {
                // feeTypeOption

                return (
                    <Flex vertical>
                        {_?.map?.(o => {
                            let model = feeTypeOption.find(id => id.value == o.feeType)
                            let unit = o.feeUnit == 'BATH' ? 'บาท' : '%'
                            return <span>{model.label} {get2DecimalPointsWithCommas(o.feeAmount)} {unit}</span>

                        })}
                    </Flex>
                )
            }
        },
    ];

    const getWhiteList = useCallback(async (page, productCode) => {
        try {
            dispatch(setIsLoading(true));
            const response = await services.getWhiteList({
                ...page,
                productCode
            });
            // console.log("response", response.data?.page.number);
            dispatch(setWhiteListData(response.data?.page?.content || []));
            setPagination({
                ...pagination,
                page: response.data?.page?.number,
                current: response.data?.page?.number + 1,
                total: response.data?.page?.totalElements,
            });
        } catch (error) {
            Alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, []);


    const getDropdownProduct = useCallback(async () => {
        try {
            dispatch(setIsLoading(true));
            const response = await services.getDropdownProduct({
                companyId: currentCompany
            });
            dispatch(setDropdownProduct(response.data || []));
        } catch (error) {
            Alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany]);

    const onSubmit = useCallback(
        async (values) => {
            setValuesChange({ ...values });
            try {
                dispatch(setIsLoading(true));
                const response = await services.getWhiteList({
                    ...values,
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    sortBy: values.sortBy,
                    page: 0,
                    size: 10,
                });

                dispatch(setWhiteListData(response.data?.page?.content || []));
                setPagination({
                    ...pagination,
                    total: response.data?.totalItems ?? response.data?.page?.totalElements,
                });
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, pagination]
    );

    useEffect(() => {
        getWhiteList({
            ...pagination,
            page: 0
        }, productCode)
    }, [productCode])

    useEffect(() => {
        getDropdownProduct()
        getEmployeeStstuaTypeOptions();
    }, [getDropdownProduct, getEmployeeStstuaTypeOptions]);





    function firstRow() {
        return (
            <>{ModalUpload()}
                {ModalHistoryFilesTable()}
                <Row justify="end" align={"middle"} style={{ gap: "10px" }}>
                    {/* <Input value={pagination.filter} onChange={(e) => {
                        setPagination({ ...pagination, filter: e.target.value })
                    }} onPressEnter={() => {
                        getWhiteList(pagination, productCode)
                    }} allowClear placeholder="search" style={{ width: "15%", borderRadius: "24px", height: "100%" }}
                        prefix={<SearchOutlined />} /> */}
                    {/* <Space size={7}> */}

                    <Button
                        size="large"
                        type="default"
                        style={{
                            boxShadow: "none", color: "#BFBFBF",
                            padding: 0,
                            width: "40px",
                            height: "40px",
                            borderRadius: "8px"
                        }}
                        onClick={() => { setAmountVisible(!amountVisible) }}
                        icon={amountVisible ? <EyeCloseIcon /> : <EyeIcon />} />

                    {/* <Select value={productCode} onChange={(e) => { setProductCode(e) }} style={{ width: "7vw" }} options={[{ label: "ทั้งหมด", value: null }, ...dropdownProduct?.map?.(o => {
                            return {
                                label: o.name,
                                value: o.productCode
                            }
                        })]} className={styles.roundSelect} place
                            holder={t('whiteList..words')} /> */}

                    <Button type="default" onClick={() => { setUseFilter(!useFilter) }} style={{ padding: "10px 16px", height: "40px", borderRadius: "8px" }}>
                        <Flex align="center" justify="center" gap={8}>
                            <FilterIcon />
                            <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                        </Flex>
                    </Button>
                    <Button style={{ width: "max-content", height: "max-content", borderRadius: "8px", padding: "10px 16px" }}
                        onClick={() => { setOpenHistoryModal(true) }}
                    >
                        <Flex align="center" justify="center" gap={8}>
                            <HistoryIcon />
                            <span style={{ color: "#344054" }}>{t("becash.label.history")}</span>
                        </Flex>
                    </Button>
                    {/* <Button onClick={() => {
                        services.exportExcelWhitelist().then(res => {
                            console.log("res", res);
                            const url = window.URL.createObjectURL(res.data);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', "import-whitelist-template.xlsx");
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        })
                    }} type="primary" style={{ borderRadius: "8px", backgroundColor: "#2cade7", color: "white", boxShadow: "none", height: "40px" }}>{t('whiteList..download')}</Button> */}
                    {/* <Button
                        onClick={() => { setOpenModal(true) }}
                        type="primary"
                        style={{ borderRadius: "8px", backgroundColor: "#30BB80", color: "white", boxShadow: "none", height: "40px" }}>{t('whiteList..upload')}</Button> */}
                    {/* </Space> */}
                </Row>
                {useFilter && (
                    <Card
                        width="100%"
                        style={{
                            borderRadius: "8px",
                            backgroundColor: "white",
                            border: "1px solid #EAECF0"
                        }}
                    >
                        <WhiteListFilter
                            setProductCode={setProductCode}
                            dropdownProduct={dropdownProduct}
                            productCode={productCode}
                            onSubmit={onSubmit}
                            employeeStatusTypeOptions={employeeStatusTypeOptions}
                        />
                    </Card>
                )}
            </>
        );
    }

    function table() {
        return (
            <TableAntd loading={isLoading} className={styles.customSelect}
                columns={columns}
                dataSource={dataSource}
                style={{ marginTop: "4vh" }}
                onChange={(pagination, filter, sorter) => {
                    console.log("pagination", pagination, sorter);
                    const modifiedSorter = Array.isArray(sorter)
                        ? [...sorter]
                        : [sorter];
                    console.log("modifiedSorter", modifiedSorter);

                    console.log("valuesChange", valuesChange);

                    getWhiteList({
                        ...valuesChange,
                        filter: pagination?.filter,
                        page: pagination?.current - 1,
                        size: pagination?.pageSize,
                        pageSize: pagination?.pageSize,
                        sortBy: modifiedSorter
                            .filter((s) => s.order !== undefined)
                            .map((s) => ({
                                direction: s.order === "descend" ? "desc" : "asc",
                                property: s.field,
                            })),
                    }, productCode)
                    setPagination({
                        filter: pagination?.filter,
                        page: pagination?.current - 1,
                        size: pagination?.pageSize,
                        pageSize: pagination?.pageSize,
                        sortBy: modifiedSorter
                            .filter((s) => s.order !== undefined)
                            .map((s) => ({
                                direction: s.order === "descend" ? "desc" : "asc",
                                property: s.field,
                            })),
                    })
                }}
                pagination={{
                    ...pagination,
                    showTotal: (total, range) =>
                        t("paginate.description")
                            .replace("{min}", range[0])
                            .replace("{max}", range[1])
                            .replace("{total}", total),
                }}
            />
        )
    }
    return {
        firstRow,
        table,
        ModalUpload,
        setOpenModal,
        dropdownProduct,
    };
}

export default useWhiteList;
